import api from '../api/api';

/**
 * Track a job view
 * @param {string} jobId - The ID of the job being viewed
 * @returns {Promise} - Promise that resolves with the tracking response
 */
export const trackJobView = async (jobId) => {
  try {
    const response = await api.post('/analytics/track-view', { jobId });
    
    return {
      success: true,
      data: response.data
    };
  } catch (error) {
    console.error('Failed to track job view:', error);
    return {
      success: false,
      error: error.response?.data?.message || 'Failed to track view'
    };
  }
};

export default {
  trackJobView
};
